// @ts-ignore
 
import request from "src/lib/axios";

/** 按订单查询押金支付账单 根据订单 ID 或订单编号查询该订单下的押金支付账单 GET /api/v1/payments/deposit-by-order */
export async function PaymentControllerGetDepositPaymentsByOrderV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.PaymentControllerGetDepositPaymentsByOrderV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputPaymentDtoArray>(
    "/api/v1/payments/deposit-by-order",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 按订单查询分期支付账单 根据订单 ID 或订单编号查询该订单下的分期/租金类支付账单（不含押金账单） GET /api/v1/payments/installments-by-order */
export async function PaymentControllerGetInstallmentPaymentsByOrderV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.PaymentControllerGetInstallmentPaymentsByOrderV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputPaymentDtoArray>(
    "/api/v1/payments/installments-by-order",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 按订单查询账单列表 根据订单 ID 或订单编号查询该订单下的账单列表 GET /api/v1/payments/order-payments-by-payment-type */
export async function PaymentControllerGetPaymentsByOrderAndPaymentTypeV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.PaymentControllerGetPaymentsByOrderAndPaymentTypeV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputPaymentDtoArray>(
    "/api/v1/payments/order-payments-by-payment-type",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}
